import React from 'react';

import {BlobLinkList} from 'notebook/data-tables/BlobLinkList';
import * as BlobActions from 'schemas/tags/BlobActions';
import {BenchlingBlob} from 'schemas/tags/BlobConstants';
import BlobInputModal from 'schemas/tags/BlobInputModal';
import {ChipSize} from 'ui-library/chips/Chip';
import ModalAnchor from 'ui-library/ModalAnchor';

interface BlobInputProps {
  allowMultiple: boolean;
  blobs: Array<BenchlingBlob>;
  onBlobsCreated: (args: {
    text: string;
    blobs: Array<BenchlingBlob>;
    filteredExistingBlobs: Array<BenchlingBlob>;
  }) => void;
  escapeHandler: () => void;
}

const BlobInput: React.SFC<BlobInputProps> = (props: BlobInputProps): JSX.Element => (
  // We show a BlobLinkList here so the previews don't go away while we are in edit mode
  <div>
    {props.blobs ? <BlobLinkList blobs={props.blobs} chipSize={ChipSize.TABLE_CELL} /> : <div />}
    <ModalAnchor open={true}>
      <BlobInputModal
        allowMultiple={props.allowMultiple}
        onRequestClose={props.escapeHandler}
        existingBlobs={props.blobs}
        onUploadFiles={(files, filteredExistingBlobs) =>
          BlobActions.uploadFilesAsBlobs(files, {
            shouldGeneratePreviewFile: true,
            onBlobsCreated: (blobs) => {
              props.onBlobsCreated({
                blobs,
                text: blobs.map((blob) => blob.name).join(', '),
                filteredExistingBlobs,
              });
            },
          })
        }
      />
    </ModalAnchor>
  </div>
);

export default BlobInput;
